// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__32N4W","left":"StickyBox_left__14iHo","right":"StickyBox_right__3Aee6"};